/* Setting Service
 *
 * This service can be used to set and retrieve user settings (i.e. grid preferences).
 */
SUGApp.service('settingService', ['sugCacheFactory', 'SUGUtilities', 'globalService', '$q', function (sugCacheFactory, SUGUtilities, globalService, $q) {
    // set internal reference
    var settingService = this;

    /*************************
        BEGIN PRIVATE METHODS
    *************************/

    /**
     * check if the server response is invalid
     *
     * @param {object} result standard response, i.e. {success, message, data}
     * @returns {boolean}
     */
    var ajaxResultInvalid = function (result) {
        return (typeof result.data === 'undefined' || !result.data.SUCCESS || !result.data.DATA);
    };

    /**
     * Parse Setting from Settings Array by Name
     *
     * @param {array} settings
     * @param {string} settingName
     * @returns {object} setting object
     */
    var parseSettingByName = function (settings, settingName) {
        var thisSetting = {};
        for (var s = 0; s < settings.length; s++) {
            if (settings[s].SETTINGNAME && settings[s].SETTINGNAME == settingName) {
                thisSetting = JSON.parse(settings[s].SETTINGSJSON);
                thisSetting.settingID = settings[s].ID;
            }
        }
        return thisSetting;
    };

    /**
     * Get Member Info
     *
     * @returns {object} member information object
     */
    var getMemberInfo = function () {
        var deferred = $q.defer();
        var memberInfo = sugCacheFactory.get('memberinfo',{});
        if (!memberInfo.memberId || memberInfo.memberId <= 0) {
            globalService.getMemberInformation().then(function (response) {
                if (ajaxResultInvalid(response)) {
                    // invalid response, reject with error message
                    deferred.reject(SUGUtilities.resultErrorHandler(response.data));
                } else {
                    // successfully retrieved member info
                    var r = SUGUtilities.lowerCaseKeys(response);
                    if (r.data && r.data.data) {
                        var memberResponseData = r.data.data;
                        if (angular.isNumber(memberResponseData.memberid) && isFinite(memberResponseData.memberid)) {
                            memberInfo.memberId = memberResponseData.memberid;
                            if (angular.isNumber(memberResponseData.parentid) && isFinite(memberResponseData.parentid)) {
                                memberInfo.parentID = memberResponseData.parentid;
                                if (memberInfo.parentID != memberInfo.memberId) {
                                    memberInfo.isSubAdmin = true;
                                }
                            }
                            sugCacheFactory.set('memberinfo', memberInfo);
                        }
                    }
                    deferred.resolve(memberInfo);
                }
            });
        } else {
            deferred.resolve(memberInfo);
        }
        return deferred.promise;
    };

    /**
     * Save settings to server
     *
     * @param {object} data
     * @returns {promise}
     */
    var saveMySettings = function (data) {
        return SUGUtilities.APISyncCall('post', '', data, 'c.saveMySettings', 15000);
    };

    /*************************
        END PRIVATE METHODS
    *************************/

    /*************************
        BEGIN PUBLIC METHODS
    *************************/

    /**
     * Get Seting Category
     *
     * @param {string} settingCategoryName
     * @returns {object} setting category object
     */
    settingService.getSettingCategory = function (settingCategoryName) {
        var deferred = $q.defer();
        var settingCategory = sugCacheFactory.get('settingCategory_' + settingCategoryName,{});
        if (!settingCategory.ID) {
            settingCategory = globalService.getSettingCategory({
                settingCategoryName: settingCategoryName
            }).then(function (r) {
                if (r.data && r.data.DATA && angular.isArray(r.data.DATA) && r.data.DATA.length && angular.isNumber(r.data.DATA[0].ID) && isFinite(r.data.DATA[0].ID)) {
                    settingCategory = r.data.DATA[0];
                    sugCacheFactory.set('settingCategory_' + settingCategoryName, settingCategory);
                } else {
                    settingCategory = {};
                }
                deferred.resolve(settingCategory);
            });
        } else {
            deferred.resolve(settingCategory);
        }
        return deferred.promise;
    };

    /**
     * Get Settings
     *
     * @param {string} settingName
     * @param {string} settingCategoryName
     * @param {boolean} blnForceRefresh
     * @returns {object} settings object
     */
    settingService.getSettingByName = function (settingName, settingCategoryName, blnForceRefresh) {
        var deferred = $q.defer();
        var thisSetting = {};
        var uniqueSettingLabel = 'setting_' + settingCategoryName + '_' + settingName;
        var mySettings = sugCacheFactory.get(uniqueSettingLabel,[]);
        if (!mySettings.length || blnForceRefresh) {
            getMemberInfo().then(
                function (memberInfo) {
                    if (memberInfo.memberId) {
                        settingService.getSettingCategory(settingCategoryName).then(function (settingCategory) {
                            if (settingCategory.ID) {
                                globalService.getMemberSettings({
                                    memberID: memberInfo.memberId,
                                    category: settingCategory.ID
                                }).then(function (r) {
                                    if (r.data.DATA && r.data.DATA.length) {
                                        mySettings = r.data.DATA;
                                        sugCacheFactory.set(uniqueSettingLabel, mySettings);
                                        thisSetting = parseSettingByName(mySettings, settingName);
                                        deferred.resolve(thisSetting);
                                    } else {
                                        sugCacheFactory.set(uniqueSettingLabel, ['No settings defined.']);
                                        deferred.resolve(thisSetting);
                                    }
                                });
                            } else {
                                deferred.resolve(thisSetting);
                            }
                        });
                    } else {
                        deferred.resolve(thisSetting);
                    }
                },
                function (error) {
                    deferred.reject(error);
                }
            );
        } else {
            thisSetting = parseSettingByName(mySettings, settingName);
            deferred.resolve(thisSetting);
        }
        return deferred.promise;
    };

    /**
     * Save Settings
     *
     * @param {number} settingId
     * @param {string} settingName
     * @param {string} settingCategoryName
     * @param {object} settingsObj
     * @param {number} memberId - if passed function will verify argument memberId matches the session's memberid
     * @returns {number} id of saved setting
     */
    settingService.saveSettings = function (settingId, settingName, settingCategoryName, settingsObj, memberId) {
        var mid = typeof memberId != 'undefined' ? memberId : 0;
        var deferred = $q.defer();
        // validate number per page if present (stop processing if empty or invalid since we must have it for proper filter/sort)
        if (settingsObj.hasOwnProperty('numPerPage') && (settingsObj.numPerPage && !(angular.isNumber(~~settingsObj.numPerPage) && isFinite(~~settingsObj.numPerPage)) || ~~settingsObj.numPerPage <= 0)  ) {
            deferred.reject({
                SUCCESS: false,
                MESSAGE: 'Items per page must be a number greater than 0.'
            });
        } else {
            getMemberInfo().then(
                function (memberInfo) {
                    if (memberInfo.memberId) {

                        // if mid was passed in with save settings, validate the active user didn't change
                        if( mid > 0 && mid != memberInfo.memberId){
                            var rsp = {success:false, code:1003, message:["There was a problem executing this page. You do not have the correct permissions."], data:""};
                            deferred.reject(rsp);
                        }

                        settingService.getSettingCategory(settingCategoryName).then(function (settingCategory) {
                            saveMySettings({
                                settingID: settingId,
                                memberid: memberInfo.memberId,
                                settingName: settingName,
                                settingCategoryID: settingCategory.ID,
                                settingJSON: settingsObj
                            }).then(
                                function (response) {
                                    if (ajaxResultInvalid(response)) {
                                        deferred.reject(response);
                                    } else {
                                        var r = SUGUtilities.lowerCaseKeys(response);
                                        //clear the cached value
                                        sugCacheFactory.set('setting_' + settingCategoryName + '_' + settingName,undefined);
                                        if (settingId === 0) {
                                            settingId = parseInt(r.data.data);
                                            deferred.resolve(settingId);
                                        } else if (settingId > 0 && parseInt(r.data.data) != settingId) {
                                            deferred.reject(response);
                                        }
                                        // This never emits a value (the caller never gets a completed promise)
                                        //  if the settingId returned from saveMySettings matches the settingId passed id (an update)
                                        //  did not alter it since multiple callers are already in place and didn't want to break anything
                                        //  instead created saveSetting method which is identical to this method but returns a value in this condition
                                    }
                                },
                                function (response) {
                                    deferred.reject(response);
                                }
                            );
                        });
                    } else {
                        // should not happen, resolve the setting back just in case
                        deferred.resolve(settingId);
                    }
                },
                function (error) {
                    deferred.reject(error);
                }
            );
        }
        return deferred.promise;
    };


    /**
     * Save Setting - Replaces settingService.saveSettings since it was already used by multiple callers but does not return a value in all situations
     *
     * @param {number} settingId - the settingId (0 if new)
     * @param {string} settingName - name of the setting
     * @param {string} settingCategoryName - setting category name
     * @param {object} settingsObj - JSON settings object to be saved
     * @returns {number} id of saved setting
     */
    settingService.saveSetting = function (settingId, settingName, settingCategoryName, settingsObj) {
        var deferred = $q.defer();

        // validate number per page if present (stop processing if empty or invalid since we must have it for proper filter/sort)
        if (settingsObj.numPerPage && !(angular.isNumber(~~settingsObj.numPerPage) && isFinite(~~settingsObj.numPerPage)) || ~~settingsObj.numPerPage <= 0) {
            deferred.reject({
                SUCCESS: false,
                MESSAGE: 'Items per page must be a number greater than 0.'
            });
        } else {
            getMemberInfo().then(
                function (memberInfo) {
                    if (memberInfo.memberId) {
                        settingService.getSettingCategory(settingCategoryName).then(function (settingCategory) {
                            saveMySettings({
                                settingID: settingId,
                                memberid: memberInfo.memberId,
                                settingName: settingName,
                                settingCategoryID: settingCategory.ID,
                                settingJSON: settingsObj
                            }).then(
                                function (response) {
                                    if (ajaxResultInvalid(response)) {
                                        deferred.reject(response);
                                    } else {
                                        var r = SUGUtilities.lowerCaseKeys(response);
                                        //clear the cached value
                                        sugCacheFactory.set('setting_' + settingCategoryName + '_' + settingName,undefined);
                                        if (settingId === 0) {
                                            settingId = parseInt(r.data.data);
                                            deferred.resolve(settingId);
                                        } else if (settingId > 0 && parseInt(r.data.data) != settingId) {
                                            deferred.reject(response);
                                        } else if ( !!parseInt(r.data.data) ){
                                            deferred.resolve( parseInt(r.data.data) );
                                        } else {
                                            deferred.reject(false);
                                        }
                                    }
                                },
                                function (response) {
                                    deferred.reject(response);
                                }
                            );
                        });
                    } else {
                        // should not happen, resolve the setting back just in case
                        deferred.resolve(settingId);
                    }
                },
                function (error) {
                    deferred.reject(error);
                }
            );
        }
        return deferred.promise;
    };

    /**
     * Get Date Format
     *
     * @returns {object} date and timezone object
     */
    settingService.getDateAndTZFormats = function () {
        var deferred = $q.defer();
        var dateAndTZFormats = sugCacheFactory.get('DateAndTZFormats',{});
        if (jQuery.isEmptyObject(dateAndTZFormats)) {
            globalService.getDateAndTZFormats().then(function (response) {
                if (ajaxResultInvalid(response)) {
                    // invalid response, reject with error message
                    deferred.reject(SUGUtilities.resultErrorHandler(response.data));
                } else {
                    // successfully retrieved
                    var r = SUGUtilities.lowerCaseKeys(response);
                    dateAndTZFormats = r.data.data;
                    sugCacheFactory.set('DateAndTZFormats', dateAndTZFormats);
                    deferred.resolve(dateAndTZFormats);
                }
            });
        } else {
            deferred.resolve(dateAndTZFormats);
        }
        return deferred.promise;
    };

    settingService.deleteSettings = function (data) {
        return SUGUtilities.APISyncCall('post', '', data, 'c.deleteSettings', 15000);
    };

    /*************************
        END PUBLIC METHODS
    *************************/

}]);